module.exports = __webpack_public_path__ + "img/3.2dfa7586.png";